'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggle = exports.close = undefined;

var _reduxActions = require('redux-actions');

var _actionTypes = require('../action-types');

var close = exports.close = (0, _reduxActions.createAction)(_actionTypes.CMS_COMPONENT_DROPDOWN_CLOSE);
var toggle = exports.toggle = (0, _reduxActions.createAction)(_actionTypes.CMS_COMPONENT_DROPDOWN_TOGGLE);